import { render, staticRenderFns } from "./PDFLoader420.vue?vue&type=template&id=761b0d82&scoped=true&"
import script from "./PDFLoader420.vue?vue&type=script&lang=ts&"
export * from "./PDFLoader420.vue?vue&type=script&lang=ts&"
import style0 from "./PDFLoader420.vue?vue&type=style&index=0&id=761b0d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761b0d82",
  null
  
)

export default component.exports